/**
 * GET /auth/sessions - Get active sessions
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import { getCookie } from 'hono/cookie'
import type { AuthService } from '../auth.service.js'

export const sessionsAction: ActionDefinition = {
  key: 'sessions',
  label: { en: 'Get Sessions', es: 'Obtener sesiones' },
  icon: 'mdi:devices',
  scope: 'module',
  hidden: true,
  method: 'GET',
  middleware: (ctx) => ctx.core.middleware['auth'] as MiddlewareHandler,
  handler: async (ctx, input, c) => {
    const { _authUserId } = input as { _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const currentToken = c ? getCookie(c, 'refreshToken') : undefined
    const authService = ctx.services.get<AuthService>('auth')
    return authService.getSessions(_authUserId, currentToken)
  }
}
